module.exports = __webpack_public_path__ + "ax.svg?ef21fff03de2a83096917ad36689bb72";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ax.svg
// module id = 997
// module chunks = 27